import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { addError } from 'actions'
import { browserHistory } from 'react-router'
import { updateState } from 'interview/actions/candidate'
import CandidateService from 'interview/services/candidate'
import { mapLanguageToComponentProps } from 'interview/i18n'
import InterviewFormWrapper from 'interview/components/interview-form-wrapper'
import { Body } from 'components/styled/typography'
import { formatDateTimeTimezone } from 'utils/date'
import { Button } from 'components/styled/button'
import ActionBarWrapper from 'components/action-bar-wrapper'
import {
  getCandidateInfoForAmplitude,
  getCompanyAndInterviewInfoForAmplitude,
} from 'selectors'

const propTypes = {
  candidate: PropTypes.shape({
    uuid: PropTypes.string,
    _id: PropTypes.string,
    videoResponses: PropTypes.arrayOf(PropTypes.object),
    completeUrl: PropTypes.string,
    agreeTOS: PropTypes.bool,
  }).isRequired,
  interview: PropTypes.shape({
    questions: PropTypes.arrayOf(PropTypes.object),
    formSetup: PropTypes.shape({}),
    language: PropTypes.string,
    company: PropTypes.shape({
      _id: PropTypes.string,
      name: PropTypes.string,
    }),
    additionalFormFields: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        type: PropTypes.string,
        required: PropTypes.bool,
      })
    ),
    endTime: PropTypes.string,
  }).isRequired,
  i18n: PropTypes.shape({
    sequencedInterview: PropTypes.shape({
      continue: PropTypes.string,
    }),
    layout: PropTypes.shape({
      endTime: PropTypes.func,
    }),
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  candidateState: PropTypes.string.isRequired,
  stateChangedAt: PropTypes.string,
  websocketError: PropTypes.string,
}

const defaultProps = {
  stateChangedAt: undefined,
  websocketError: undefined,
}

const mapStateToProps = state => ({
  candidate: state.candidate,
  candidateState: state.interview.candidate.state,
  stateChangedAt: state.interview.candidate.stateChangedAt,
  interview: state.interview.jobOpening,
  websocketError: state.global.websocketError,
})

export class SequencedInterview extends Component {
  constructor(props) {
    super(props)

    this.state = {
      submitting: false,
    }

    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    const {
      candidateState,
      candidate: { uuid },
    } = this.props
    if (candidateState && candidateState === 'networktest') {
      browserHistory.replace(`/sequenced-interview/${uuid}/test`)
    } else if (candidateState && candidateState.includes('question')) {
      browserHistory.replace(`/sequenced-interview/${uuid}/questions`)
    }
  }

  componentDidUpdate(prevProps) {
    const {
      candidateState,
      stateChangedAt,
      candidate: { uuid, completeUrl },
      websocketError,
    } = this.props
    if (
      stateChangedAt !== prevProps.stateChangedAt &&
      candidateState === 'completed'
    ) {
      if (completeUrl) {
        window.location.href = completeUrl
      } else {
        browserHistory.push('/sequenced-interview/finished')
      }
    } else if (candidateState !== prevProps.candidateState) {
      this.setState({ submitting: false })
      if (
        candidateState === 'networktest' ||
        candidateState.includes('question')
      ) {
        browserHistory.replace(`/sequenced-interview/${uuid}/test`)
      }
    }

    if (
      websocketError !== prevProps.websocketError &&
      websocketError.length > 0
    ) {
      this.setState({ submitting: false })
    }
  }

  onSubmit() {
    const { dispatch, candidate } = this.props
    this.setState({ submitting: true })
    CandidateService.update(candidate)
      .then(() => {
        dispatch(updateState(candidate.uuid))
      })
      .catch(err => {
        this.setState({ submitting: false })
        addError(err)
      })
  }

  render() {
    const { i18n, interview, candidate } = this.props
    const { submitting } = this.state
    const candidateInfo = getCandidateInfoForAmplitude(candidate)
    const companyAndInterviewInfo =
      getCompanyAndInterviewInfoForAmplitude(interview)

    return (
      <>
        <InterviewFormWrapper onSubmit={this.onSubmit}>
          <ActionBarWrapper
            hideBeforeScroll
            leftSideComponent={
              interview.endTime && (
                <Body fontWeight={600}>
                  {i18n.layout.endTime(
                    formatDateTimeTimezone(interview.endTime)
                  )}
                </Body>
              )
            }
            actions={
              <Button
                onClick={() => document.interviewForm.submit()}
                disabled={!candidate.agreeTOS}
                loading={submitting}
                text={i18n.sequencedInterview.continue}
                event={{
                  locationId: 'timedInterviewPage',
                  id: 'continueToNetworkTestButton',
                  properties: {
                    ...candidateInfo,
                    ...companyAndInterviewInfo,
                  },
                }}
                iconRight={interview.language === 'ar' ? 'west' : 'east'}
              />
            }
          />
        </InterviewFormWrapper>
      </>
    )
  }
}

SequencedInterview.propTypes = propTypes
SequencedInterview.defaultProps = defaultProps

export default connect(mapLanguageToComponentProps(mapStateToProps))(
  SequencedInterview
)
